import {FeedbackBadge} from '../../../../components/ai/DisclosureControls';
import React from 'react';

import Avatar from '../../../../components/avatar/avatar';
import './textSurveyAnswersList.css';

const TextSurveyAnswersList = ({
  answers,
  onFilter
}) => {
  if (!answers || answers.length === 0) {
    return <p role="status" style={{color: 'var(--br-muted)'}}>No answers yet.</p>;
  }

  return (
    <ul className="br-survey-text-answers">
      {
        answers.map((answer) => {
          return (
            <li
              key={answer._id + answer.reader._id}
            >
              <Avatar
                name={answer.reader && answer.reader.displayName}
                diameter={25}
                userId={answer.reader && answer.reader.userId}
                src={answer.reader && answer.reader.photoUrl}
                onClick={() => onFilter && onFilter([answer.reader._id])}
              />
              <div className="br-survey-text-answers__content">
                <FeedbackBadge origin={answer.aiOrigin} /> {answer.answer}
              </div>
            </li>
          )
        })
      }
    </ul>
  );

}

export default TextSurveyAnswersList;
